module.exports = __webpack_public_path__ + "24e004ab/img/share-action-icon.9c12578c.svg";